export default "__VITE_ASSET__cg9YKhop__"